var vertical_embed_viewer_default = {
  "card": "RGoV3",
  "slimLayout": "kQwmf",
  "cardLayout": "C5ynR",
  "imageContainer": "qqpS7",
  "image": "VNw6X",
  "content": "HS-SU"
};
export {
  vertical_embed_viewer_default as default
};
//# sourceMappingURL=vertical-embed-viewer-scss.js.map
